<template>
  <div>
    <div
      v-if="isEditMode"
      :class="$style.paymentsContainer"
    >
      <CircledCharacter>
        {{ stepNumber }}
      </CircledCharacter>
      <BillingInformationEdit
        data-test-id="BillingInformationSection__payments"
        :hasReachedSection="hasReachedSection"
        :location="location"
        :orgId="id"
        :section="section"
        @cancelled="handleCancel"
        @error="handleError"
        @submitted="handleSubmitted"
        @success="handleSuccess"
      />
    </div>

    <BillingInformationReview
      v-else
      :hasReachedSection="hasReachedSection"
      :isMinimized="isMinimized"
      :paymentDetails="item"
      :stepNumber="stepNumber"
      @edit="handleEdit"
    />
  </div>
</template>

<script>
import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters, mapState } from 'vuex';
import { paymentFormSections } from 'client/Payments/constants/PaymentConstants';
import { paymentModuleName } from '@jumpcloud/ui-payments';
import BillingInformationEdit from 'client/Payments/newComponents/BillingInformationEdit.vue';
import BillingInformationReview from 'client/Payments/newComponents/BillingInformationReview.vue';
import CircledCharacter from 'client/Payments/newComponents/CircledCharacter.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const {
  description,
  location,
  section,
  text: textEventProp,
} = eventProperties;
const {
  billingInformationSection,
} = paymentFormSections;
const settingsModule = 'SettingsModule';

export default {
  name: 'BillingInformationSection',

  EventHelper,

  components: {
    BillingInformationEdit,
    BillingInformationReview,
    CircledCharacter,
  },

  props: {
    hasReachedSection: Boolean,
    id: {
      type: String,
      required: true,
    },
    isEditMode: Boolean,
    isMinimized: Boolean,
    location: {
      type: String,
      required: true,
    },
    section: {
      type: String,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapState(paymentModuleName, [
      'item',
    ]),
    ...mapGetters(settingsModule, ['isProvider']),
    ...mapGetters(paymentModuleName, ['areRequiredPaymentFieldsSet']),

  },

  methods: {
    handleCancel() {
      this.$emit('cancelled');
    },

    handleEdit() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Edit clicked on Billing Information Section',
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Edit',
      });

      this.$emit('clickedEdit', billingInformationSection);
    },

    handleError(message) {
      this.$emit('error', message);
    },

    handleSubmitted() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'Continue clicked on Billing Information Section',
        [location]: this.location,
        [section]: this.section,
        [textEventProp]: 'Continue',
      });
    },

    handleSuccess(isBillingEdited) {
      this.$emit('clickedContinue', isBillingEdited);
    },
  },
};
</script>

<style module scoped>
.paymentsContainer {
  display: flex;
  gap: var(--jc-spacer);
}
</style>
